import * as React from "react";

import {
  getCandidateDeclarationAnswers,
  nvdSuggestedValueMap,
} from "components/AttachmentForm/constants";
import { OptionTogglerField } from "components/Form/FormikControls";

import { useFieldValue } from "hooks";
import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { getPropertyById } from "selectors";

export const NVD_OPTIONS = {
  YES: true,
  NO: false,
  NOT_ANSWERED: null,
};

const NVDChoices = [
  {
    value: NVD_OPTIONS.YES,
    label: "Yes",
  },
  {
    value: NVD_OPTIONS.NO,
    label: "No",
  },
  {
    value: NVD_OPTIONS.NOT_ANSWERED,
    label: "Not Answered",
  },
];
const buildAdditionalInfoFromProperty = property =>
  [
    property?.msaNumber && `MSA: ${property.msaNumber}`,
    property?.lpaNumber && `LPA: ${property.lpaNumber}`,
  ]
    .filter(Boolean)
    .join(" ");

export function useSuggestionMap() {
  const candidateDecSource = useFieldValue("candidateDeclaration.source");
  const vendorPropertyId = useFieldValue("vendor_property_id");
  const vendorProperty = useSelector(getPropertyById(vendorPropertyId));
  const sourceNvdSuggestedValueMap =
    nvdSuggestedValueMap[candidateDecSource] || null;

  const additionalInformationSuggested = useCallback(
    formikValues => {
      const eNvdAdditionalInfo = getCandidateDeclarationAnswers(
        formikValues,
      ).find(a => a.questionId === "151")?.value;
      return (
        [eNvdAdditionalInfo, buildAdditionalInfoFromProperty(vendorProperty)]
          .filter(Boolean)
          .join(" ") || ""
      );
    },
    [vendorProperty],
  );

  const suggestionMap = useMemo(
    () => ({
      ...sourceNvdSuggestedValueMap,
      // Sheep Q7
      // this generates a dynamic suggestion based on the currently selected property
      "declaration.additional_information": additionalInformationSuggested,
    }),
    [sourceNvdSuggestedValueMap, additionalInformationSuggested],
  );
  return suggestionMap;
}

export const NVDOptionToggler = React.memo(
  ({ label, name, labelPosition = "left" }) => {
    const suggestedValueMap = useSuggestionMap();
    return (
      <OptionTogglerField
        options={NVDChoices}
        label={label}
        name={name}
        labelPosition={labelPosition}
        suggestedValueFieldName={suggestedValueMap[name]}
      />
    );
  },
);

const DatePurchasedChoices = [
  {
    value: "A",
    label: "< 2",
  },
  {
    value: "B",
    label: "2-6",
  },
  {
    value: "C",
    label: "6-12",
  },
  {
    value: "D",
    label: "> 12",
  },
];

export const DatePurchasedOptionsToggler = ({ label, name, labelPosition }) => {
  const suggestedValueMap = useSuggestionMap();
  return (
    <OptionTogglerField
      options={DatePurchasedChoices}
      label={label}
      name={name}
      labelPosition={labelPosition}
      suggestedValueFieldName={suggestedValueMap[name]}
    />
  );
};
